<template>
  <div class="container mx-auto">
    <div class="mx-4 mt-8">
      <div class="pb-6">
        <doe-page-heading :label="`A PIN has been sent to your service email address: ${maskEmail($route.params.email)}`" :description="[
            'A six digit PIN has been sent to the service email address listed in NQA ITS. If you do not recognise the email address, please first check the NQA ITS system to confirm the service email address is listed correctly.',
            'If you do not have access to NQA ITS, or do not have access to the email address listed in NQA ITS, please refer to your provider or the person in your organisation responsible for managing your service\'s information in NQA ITS.',
            'The PIN will expire in 60 minutes.'
          ]
        " />
      </div>
      <div class="mb-6">
        <label
          class="block font-light font-sans leading-snug mb-2 subpixel-antialiased text-xl text-black w-full"
        >
          Enter the six-digit PIN below:
        </label>
        <input
          class="mb-4 md:mb-0 bg-gray-300 border border-gray-800 rounded font-sans leading-snug max-w-2xl px-3 py-2 subpixel-antialiased text-gray-900 text-xl w-full"
          name="pin"
          v-model="q"
          v-validate="{ required: true, regex: /^[0-9]{6}$/ }"
          data-vv-validate-on="input"
          data-vv-as="PIN"
        />
        <doe-error v-if="errors.has('pin')" description="pin">{{ errors.first('pin') }}</doe-error>
      </div>
      <div class="mb-6">
        <doe-button
          class="mr-4 mb-2"
          :disabled="!isFormInvalid"
          appearance="primary"
          size="large"
          @click="confirmPin()"
        >
          Verify
        </doe-button>
        <doe-button
          :disabled="isFormInvalid"
          appearance="secondary"
          size="large"
          @click="resendPin()"
        >
          Re-send PIN
        </doe-button>
      </div>
      <form-generator :schema="schema" @form:next="formNext()" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { serviceCallWithAuth } from "@/helpers/cognito";
import handleRoles from "@/mixins/handleRoles";
import schema from "@/schemas/service/serviceVerify";
import FormGenerator from "@/components/form/FormGenerator";
import DoePageHeading from "@/components/typography/PageHeading";
import DoeError from "@/components/field/Error";
import DoeButton from "@/components/button/Button";
import axios from 'axios';

export default {
  name: "ServiceVerify",
  mixins: [handleRoles],
  inject: {
    $validator: "$validator"
  },
  components: {
    FormGenerator,
    DoePageHeading,
    DoeError,
    DoeButton
  },
  data() {
    return {
      schema: schema,
      q: ""
    };
  },
  computed: {
    ...mapGetters(["getRegisterService"]),
    service() {

      return this.getRegisterService;
    },
    isFormInvalid() {
      if(this.q.length === 0) {
        return true;
      }
      if(this.errors.has('pin')) {
        return true;
      }
      return false;
    },
    profile() {
      return this.$OAuth.data.profile;
    },
    aclArr() {
      if(this.profile) {
        return Array.isArray(this.profile.acl) ? this.profile.acl : [this.profile.acl];
      }
      return [];
    }
  },
  methods: {
    ...mapActions(["CLEAR_REGISTER_SERVICE"]),
    confirmPin() {
      this.$root.isLoading = true;
      let headers = this.$OAuth.buildHttpHeader();
      let body = {
        seNumber: this.service[0].serviceId,
        action: "VERIFIED",
        pin: this.q,
        requestedByUserId: this.profile.detuserid
      };
      let options = {
        path: "/director-pin",
        method: "POST",
        body: JSON.stringify(body),
        headers: headers
      };
      serviceCallWithAuth("doe-ttss", options)
        .then((resp) => {
          localStorage.removeItem('access_token');
            if(resp.statusCode===403)
          {
              this.$root.translateModal(
              resp.body.toString(),
              "Error");
          //  this.$router.push({ name: "onboarding-users" });
          } else {

            //add the new Service to ESAM DB <todo>

             let userid = this.profile.detuserid;
              console.log("userid...."+userid )
             let serviceId = this.service[0].serviceId;
                       console.log("serviceId...."+serviceId )

          const headers = {
            ...this.$OAuth.buildHttpHeader(),
            'isportal': true,
            'ssotoken' : localStorage.getItem("id_token"),
        } 
      

             const endpoint = `${this.$config.serverUrl}/api/user-details/createserviceportal`
          console.log("endpoint"+endpoint)
         
           axios.post(endpoint,{'userId':userid, 'serviceId':serviceId} , {headers}).then(function (response) {
            console.log(response)
          }).catch(function (error) {
            console.log(error);
          });


            this.CLEAR_REGISTER_SERVICE();


            this.$root.translateModal(
              "The service has been registered. It will be added to your dashboard shortly.",
              "Success", 
              {
                withoutCancelBtn: true,
                action: () => {
                  this.$router.push({ name: "service-dashboard" });
                }
              });
            // this.$router.push({ name: "service-dashboard" });
          }
        })
        .catch((err) => {
          console.log("err............"+err)
        // alert("in serviceverifyvue........................"+err)

        //  alert("stop catch err")
          this.$root.translateModal(
            "For more information, please contact the department’s Information and Enquiries team on 1800 619 113 (toll free) or at information@earlylearningcommission.nsw.gov.au.",
            "Your service can't be registered"
          );
        })
        .finally(() => {
          this.$root.isLoading = false;
        });
    },
    resendPin() {
      this.$root.isLoading = true;
      let headers = this.$OAuth.buildHttpHeader();
      let body = JSON.stringify({
        seNumber: this.service[0].serviceId,
        action: "VERIFY",
        requestedByUserId: this.profile.detuserid
      });
      let options = {
        path: "/director-pin",
        method: "POST",
        body: body,
        headers: headers
      };
      serviceCallWithAuth("doe-ttss", options)
        .catch(() => {
          this.service = {};
          this.$root.translateModal(
            "For more information, please contact the department’s Information and Enquiries team on 1800 619 113 (toll free) or at information@earlylearningcommission.nsw.gov.au.",
            "Your service can't be registered"
          );
        })
        .finally(() => {
          this.$root.isLoading = false;
        });
    },
    formNext() {
      this.$router.push({ name: "service-dashboard" });
    },
    maskEmail(email) {
      if (!email) return 'your registered email address';
      var result = email.split("@");
      var mask = "";
      for (var i = 0; i < result[0].length; i++) {
        if(i == 0 || i == result[0].length - 1) {
          mask += result[0].charAt(i);
        } else {
          mask += "*";
        } 
      }
      return `${mask}@${result[1]}`;
    }
  }
};
</script>

<style lang="scss" scoped></style>
